<fa-icon [style.font-size.px]="size" [icon]="['fas', 'seal-exclamation']"></fa-icon>
